(function () {
  'use strict';

  /* Announcement rotator */
  var msgs = document.querySelectorAll('.announcement__msg');
  if (msgs.length > 1) {
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4200);
  }

  /* Drawers */
  function setDrawer(name, open) {
    var d = document.querySelector('[data-drawer="' + name + '"]');
    if (!d) return;
    d.classList.toggle('is-open', open);
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      var inp = d.querySelector('input[type=search]');
      if (inp) setTimeout(function () { inp.focus(); }, 200);
    }
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { setDrawer(opener.getAttribute('data-drawer-open'), true); return; }
    if (e.target.closest('[data-drawer-close]')) {
      document.querySelectorAll('.drawer.is-open').forEach(function (d) { setDrawer(d.getAttribute('data-drawer'), false); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open').forEach(function (d) { setDrawer(d.getAttribute('data-drawer'), false); });
    }
  });

  /* Collection: sort, filters, columns */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  var filters = document.querySelector('[data-filters]');
  if (filters) {
    filters.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams();
      new FormData(filters).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }
  var grid = document.querySelector('[data-grid]');
  document.querySelectorAll('[data-cols]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!grid) return;
      grid.setAttribute('data-cols', btn.getAttribute('data-cols'));
      document.querySelectorAll('[data-cols]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var v = (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty'), 10);
    input.value = Math.max(min, v);
  });

  /* Toast + cart count */
  function toast(msg) {
    var t = document.querySelector('.cart-toast');
    if (!t) { t = document.createElement('div'); t.className = 'cart-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-show');
    setTimeout(function () { t.classList.remove('is-show'); }, 2400);
  }
  function refreshCount() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var el = document.querySelector('[data-cart-count]');
      if (el) el.textContent = c.item_count;
    });
  }

  /* AJAX add from cards and product page */
  function ajaxAdd(form, btn) {
    var original = btn ? btn.textContent : '';
    if (btn) btn.disabled = true;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { toast('Added to your cart'); return refreshCount(); })
      .catch(function () { toast('Could not add this item'); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-ajax-add]') || f.matches('[data-product-form]')) {
      e.preventDefault();
      ajaxAdd(f, f.querySelector('button[type=submit]'));
    }
  });

  /* Product page: thumbs + variant picking */
  var main = document.getElementById('PdpMainImage');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (main) main.src = t.getAttribute('data-thumb');
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  var root = document.querySelector('[data-product]');
  if (root) {
    var dataEl = root.querySelector('[data-variants]');
    if (dataEl) {
      var variants = JSON.parse(dataEl.textContent);
      var idInput = root.querySelector('[data-variant-id]');
      var addBtn = root.querySelector('[data-add-btn]');
      var priceEl = root.querySelector('[data-price]');
      var money = function (cents) {
        var n = (cents / 100);
        return 'Rs. ' + (n % 1 === 0 ? n.toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2 }));
      };
      var update = function () {
        var chosen = [];
        root.querySelectorAll('.pdp__option').forEach(function (g) {
          var c = g.querySelector('input:checked');
          chosen.push(c ? c.value : null);
        });
        var match = variants.find(function (v) {
          return v.options.every(function (o, idx) { return o === chosen[idx]; });
        });
        if (!match) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
        idInput.value = match.id;
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceEl.innerHTML = '<s>' + money(match.compare_at_price) + '</s> <span class="is-sale">' + money(match.price) + '</span>';
        } else {
          priceEl.textContent = money(match.price);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
        if (match.featured_image && main) main.src = match.featured_image.src;
      };
      root.querySelectorAll('.pdp__option input').forEach(function (i) { i.addEventListener('change', update); });
    }
  }
})();
